import dayjs from "dayjs"

import { RestaurantStatus } from "@/lib/types"
import { cn } from "@/lib/utils"

interface RestoCloseStatusProps {
  isClosed: boolean
  endTime: string
  nextSlotTime: string
  className?: string
  status?: RestaurantStatus
}

export function RestoCloseStatus({
  isClosed,
  endTime,
  nextSlotTime,
  className,
  status,
}: RestoCloseStatusProps) {
  let statusText = ""
  let statusColor = "text-zinc-700" // Default color

  const now = dayjs()
  const closeTime = endTime ? dayjs(endTime) : null
  const openTime = nextSlotTime ? dayjs(nextSlotTime) : null

  // Check if restaurant is permanently closed (STOP status) or temporarily closed
  if (isClosed) {
    if (status === RestaurantStatus.Stop || !openTime) {
      // Restaurant is permanently closed or has no next slot time
      statusColor = "text-red-500"
      statusText = "Đã đóng cửa"
    } else {
      // Restaurant is temporarily closed with future opening time
      statusColor = "text-blue-600"
      const isOpeningToday = openTime.isSame(now, "day")

      if (isOpeningToday) {
        statusText = `Mở cửa vào lúc ${openTime.format("HH:mm")}`
      } else {
        // Different day opening format
        statusText = `Mở cửa vào lúc ${openTime.format("HH:mm")} ngày ${openTime.format("DD/MM")}`
      }
    }
  } else if (closeTime) {
    // Restaurant is open - check if closing soon
    const minutesToClose = closeTime.diff(now, "minutes")

    if (minutesToClose <= 0) {
      // Already passed closing time but not marked as closed yet
      statusColor = "text-red-500"
      statusText = "Đã đóng cửa"
    } else if (minutesToClose < 60) {
      // Closing within 60 minutes (matching Flutter's threshold)
      statusColor = "text-orange-500"
      statusText = `Đóng cửa trong ${minutesToClose} phút nữa`
    }
  }

  // Don't render if there's no status to display
  if (!statusText) {
    return null
  }

  return (
    <p
      className={cn(
        "text-sm font-medium font-be-vietnam",
        statusColor,
        className
      )}
    >
      {statusText}
    </p>
  )
}
